import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface ImageSliderProps {
  images: string[];
  alt?: string;
}
export function ImageSlider({
  images,
  alt = 'Product image'
}: ImageSliderProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  return <div className="w-full max-w-2xl" data-id="element-130">
      {/* Main Image Display */}
      <div className="w-full aspect-square bg-gray-100 rounded-2xl overflow-hidden border border-gray-200 mb-4 relative" data-id="element-131">
        <AnimatePresence mode="wait" data-id="element-132">
          <motion.img key={activeIndex} src={images[activeIndex]} alt={`${alt} ${activeIndex + 1}`} className="w-full h-full object-cover" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.3
        }} data-id="element-133" />
        </AnimatePresence>
      </div>

      {/* Thumbnail Strip */}
      <div className="grid grid-cols-3 gap-3" data-id="element-134">
        {images.map((image, index) => <motion.button key={index} onClick={() => setActiveIndex(index)} className={`aspect-square rounded-lg overflow-hidden border-2 transition-all duration-200 ${activeIndex === index ? 'border-brand-red shadow-lg' : 'border-gray-200 hover:border-gray-400'}`} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} aria-label={`View image ${index + 1}`} aria-pressed={activeIndex === index} data-id="element-135">
            <img src={image} alt={`${alt} thumbnail ${index + 1}`} className="w-full h-full object-cover" data-id="element-136" />
          </motion.button>)}
      </div>
    </div>;
}